/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A detailed error or warning resulting from processing a transfer.
 * @export
 * @interface TransferException
 */
export interface TransferException {
    /**
     * The activity in the workflow the transfer exception happened in.
     * @type {string}
     * @memberof TransferException
     */
    activity?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransferException
     */
    exceptionCreatedAt?: Date;
    /**
     * Identifier of transfer exception.
     * @type {number}
     * @memberof TransferException
     */
    id: number;
    /**
     * Transfer exception name.
     * @type {string}
     * @memberof TransferException
     */
    name?: string;
    /**
     * The object that triggered the transfer exception. E.g.: a transfer, or a specific folder or file within the transfer.
     * @type {string}
     * @memberof TransferException
     */
    object?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferException
     */
    transferExceptionType: TransferExceptionTransferExceptionTypeEnum;
    /**
     * Identifier of transfer to which this error belongs.
     * @type {string}
     * @memberof TransferException
     */
    transferId: string;
}


/**
 * @export
 */
export const TransferExceptionTransferExceptionTypeEnum = {
    Warning: 'Warning',
    CriticalError: 'Critical Error',
    NonCriticalError: 'Non-critical Error'
} as const;
export type TransferExceptionTransferExceptionTypeEnum = typeof TransferExceptionTransferExceptionTypeEnum[keyof typeof TransferExceptionTransferExceptionTypeEnum];


/**
 * Check if a given object implements the TransferException interface.
 */
export function instanceOfTransferException(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "transferExceptionType" in value;
    isInstance = isInstance && "transferId" in value;

    return isInstance;
}

export function TransferExceptionFromJSON(json: any): TransferException {
    return TransferExceptionFromJSONTyped(json, false);
}

export function TransferExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferException {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activity': !exists(json, 'activity') ? undefined : json['activity'],
        'exceptionCreatedAt': !exists(json, 'exception_created_at') ? undefined : (new Date(json['exception_created_at'])),
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'object': !exists(json, 'object') ? undefined : json['object'],
        'transferExceptionType': json['transfer_exception_type'],
        'transferId': json['transfer_id'],
    };
}

export function TransferExceptionToJSON(value?: TransferException | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activity': value.activity,
        'exception_created_at': value.exceptionCreatedAt === undefined ? undefined : (value.exceptionCreatedAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'object': value.object,
        'transfer_exception_type': value.transferExceptionType,
        'transfer_id': value.transferId,
    };
}

